"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCancelTokenSource = exports.isCancel = void 0;
var deferred_1 = __importDefault(require("./deferred"));
var CANCEL_OP = {};
function isCancel(maybeCancelOp) {
    return maybeCancelOp === CANCEL_OP;
}
exports.isCancel = isCancel;
function createCancelTokenSource() {
    var deferred = new deferred_1.default();
    return {
        cancel: function () { return deferred.resolve(CANCEL_OP); },
        token: {
            promise: deferred.promise,
        },
    };
}
exports.createCancelTokenSource = createCancelTokenSource;
//# sourceMappingURL=cancel-token.js.map